import { DeviceType } from './Device';
import { DefaultSku, ISku } from './Sku';

export interface IPlanSku {
    id: string;
    planId: string;
    planName: string;
    deviceType: DeviceType;
    lineNumber: number;
    sku: ISku;
}

export const DefaultPlanSku = (): IPlanSku => {
    return {
        deviceType: DeviceType.Other,
        id: '',
        lineNumber: 0,
        planId: '',
        planName: '',
        sku: DefaultSku()
    };
};
